import { Button, Form, Select } from 'antd'
import React, { useCallback, useContext, useEffect } from 'react'
import { AppSettingsContext, IAppliedFilters } from '../../../../App/AppSettingsContextContainer';
import { INotificationsLegendDataItem, MapContext } from '../../../../App/MapContextContainer';
import { reduceOptionValues } from '../../../../components/MapMenu/Filters';
import { ICollection, ITaxon, ObservationsContext } from '../../ObservationsContextContainer';
import CustomSliderWithLabels from '../../../../components/MapMenu/CustomSliderWithLabels';
import { monthsSince042020, monthsSinceFirstDeclarations, useLocalizedSort } from '../../../utils';
import { useTranslation } from 'react-i18next';
import TranslatedOption, { useTranslatedOptionFilter } from '../../../../components/TranslatedOption/TranslatedOption';
const { Option } = Select;

export default function ObservationFilters() {
    const [form] = Form.useForm();
    const observationsContext = useContext(ObservationsContext);
    const mapContext = useContext(MapContext);
    const appSettingsContext = useContext(AppSettingsContext);
    const { t, i18n } = useTranslation(["observations", "sidePanelTabs"]);

    const sortingFnForCuttingRealizationPractice = useLocalizedSort();
    const sortingFn = useLocalizedSort();

    const onFinish = (values: any) => {
        if (values.cuttingRealizationPractice || values.declarationArrivalMonths) {
            appSettingsContext.setAppliedFilters({
                cuttingRealizationPractices: values.cuttingRealizationPractices || [],
                declarationArrivalMonths: values.declarationArrivalMonths || []
            } as IAppliedFilters);
        }

        if (!values.declarationArrivalMonths && !values.observationMonth && !values.ERITYINENELINYMPARISTO && (!values.taxonIds || values.taxonIds.length === 0) &&
            (!values.collectionIds || values.collectionIds.length === 0) && (!values.cuttingRealizationPractices || values.cuttingRealizationPractices.length === 0)) {
            observationsContext.observationsStateDispatch({ type: "reset" });

            appSettingsContext.setAppliedFilters({
            } as IAppliedFilters);
        }
        else {
            observationsContext.observationsStateDispatch({
                type: 'setAllSearchCriteria',
                collectionIds: values.collectionIds || [],
                cuttingRealizationPractices: values.cuttingRealizationPractices || [],
                declarationArrivalMonths: values.declarationArrivalMonths || [],
                observationMonths: values.observationMonth || [],
                taxonIds: values.taxonIds || []
            });
        }
    };

    const onReset = () => {
        form.resetFields();

        observationsContext.observationsStateDispatch({ type: "reset" });
        appSettingsContext.setAppliedFilters({} as IAppliedFilters);
    };

    useEffect(() => {
        if (observationsContext.observationsState) {
            form.setFieldsValue(observationsContext.observationsState);
        }
    }, [observationsContext.observationsState]);

    const { filterOptionFn } = useTranslatedOptionFilter();

    return <div>
        <Form form={form} name="control-hooks" onFinish={onFinish} layout={'vertical'}>
            <Form.Item
                name="collectionIds"
                label={t("suodattimetLajiKokoelmat")}
            >
                <Select
                    placeholder={t("sidePanelTabs:valitsePlaceHolder")}
                    allowClear
                    showSearch
                    filterOption={filterOptionFn}
                    onFocus={() => window.blur()}
                    mode='multiple'
                >
                    {
                        observationsContext.observationsState.allCollections?.sort(sortingFn).map((collection: ICollection) => (
                            <Option value={collection.id} key={collection.id}><TranslatedOption toTranslate={collection} /></Option>
                        ))
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name="taxonIds"
                label={t("suodattimetLajit")}
            >
                <Select
                    placeholder={t("sidePanelTabs:valitsePlaceHolder")}
                    allowClear
                    showSearch
                    filterOption={filterOptionFn}
                    onFocus={() => window.blur()}
                    mode='multiple'
                >
                    {
                        observationsContext.observationsState.allTaxons?.sort(sortingFn).map((taxon: ITaxon) => (
                            <Option value={taxon.id} key={taxon.id}><TranslatedOption toTranslate={taxon} /></Option>
                        ))
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name="cuttingRealizationPractices"
                label={t("sidePanelTabs:hakkuunToteutusTapa")}
            >
                <Select
                    placeholder={t("sidePanelTabs:valitsePlaceHolder")}
                    allowClear
                    onFocus={() => window.blur()}
                    mode='multiple'
                >
                    {
                        mapContext.legendData?.sort(sortingFnForCuttingRealizationPractice).map((legendItem: INotificationsLegendDataItem) => (
                            <Option value={reduceOptionValues(legendItem.values)} key={legendItem.nameFi}><TranslatedOption toTranslate={legendItem} /></Option>
                        ))
                    }
                </Select>
            </Form.Item>
            {/* <Form.Item
                name="clashDateAfter"
                label="Clashin pvm jälkeen">
                    <CustomSliderWithLabels minVal={-360} maxVal={0} valueType={'DATE'} />
            </Form.Item> */}
            <Form.Item
                name="declarationArrivalMonths"
                label={t("sidePanelTabs:ilmoituksenTuloKuukausi")}
            >
                <CustomSliderWithLabels valueType='DATE'
                    initialMinVal={appSettingsContext.appliedFilters?.declarationArrivalMonths?.at(0) !== undefined ?
                        appSettingsContext.appliedFilters?.declarationArrivalMonths?.at(0) :
                        -monthsSince042020}
                    initialMaxVal={appSettingsContext.appliedFilters?.declarationArrivalMonths?.at(1)}
                    minVal={-monthsSinceFirstDeclarations} maxVal={0} />
            </Form.Item>
            <div>
                <Form.Item
                    name="observationMonth"
                    label={t("suodattimetLajiHavainnonSaapumisKuukausi")}
                >
                    <CustomSliderWithLabels minVal={-360} maxVal={0} valueType={'DATE'}
                        initialMinVal={observationsContext.observationsState.observationMonths?.at(0)}
                        initialMaxVal={observationsContext.observationsState.observationMonths?.at(1)} />
                </Form.Item>
            </div>
            {/* <Form.Item
                name="ERITYINENELINYMPARISTO"
                label="Erityinen elinympäristö"
            >
                <Input type="text"></Input>
            </Form.Item> */}
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    {t("sidePanelTabs:käytäNappula")}
                </Button>
                <Button htmlType="button" onClick={onReset}>
                    {t("sidePanelTabs:tyhjennäNappula")}
                </Button>
            </Form.Item>
        </Form>
    </div>
}
